/* eslint-disable no-extend-native */

import {isElement} from "react-dom/test-utils";

export const MS_DAY = 1000*60*60*24;
export const secUnits = {second: 1, minute: 60, hour: 60*60, day: 60*60*24, year: 60*60*24*365};
export const secUnitsBiz = {second: 1, minute: 60, hour: 60*60, day: 60*60*8, week: 60*60*8*5, year: 60*60*8*5*52};
export const minUnitsBiz = {second: 1/60, minute: 1, hour: 60, day: 60*8, week: 60*8*5, year: 60*8*5*52};
export const units = Object.keys(secUnits), unitVals = Object.values(secUnits);

// flags: long, addDate
export const get_durSingle = (ms, flags) => {
    const {long, addDate} = flags || {};
    const sec = ms / 1000 >> 0;
    const unit = units.find((u,i) => i === units.length-1 || sec < unitVals[i+1]*2);
    const val = sec / secUnits[unit] >> 0;
    const str = val + (!long? unit[0] : " "+ unit + (val === 1? "" : "s"));
    //return !addDate? str : `${str} ago (${dt.toLocaleString(locale || "en-US")})`;
};

/** 
 * Converts number of seconds or milliseconds to sexagesimal or other viewable string formats.
 *  @param addUnit (number)?: 1: add 1 character for unit (e.g: 1h:22m), 2: add full unit name (e.g.: 1 hour: 22 minutes)
 *  @param topOnly (number)?: only return most significant (number) of units.
 *  @param trimUnits remove all 0 units, except the last 1.
 *  @param trimLeftZero trims left most zero if 2 digit number or decimals if 0.
 * */
export const get_dur = (msSec, {isSec, sep = ":", addUnit, topOnly, trimUnits, trimLeftZero, showMs, altUnits} ={}) => {
    const uv = altUnits? Object.values(altUnits) : unitVals;
    const ut = altUnits? Object.keys(altUnits) : units;
    let secs = isSec? msSec : msSec / 1000, parts = [];

    for (let i = 0; !i || secs >= uv[i]-1; i++) {
        const dv = secs % (uv[i+1] || secs+1) / uv[i];
        const str = !i && showMs && (!trimUnits || secs < 10)? (dv * 1000 |0) / 1000 :
            !addUnit? String(dv |0).padStart(2,'0') : String(dv |0);
        parts.unshift(str + (addUnit === 1? ut[i][0] : addUnit === 2? ` ${ut[i] + (dv | 0).plural}` : ""));
    }
    if (topOnly)
        parts = parts.slice(0, topOnly);
    if (trimUnits) {
        const last = parts.last;
        parts = parts.filter(p => !p.match(/^00?(\.000)?[a-z]?$/));
        if (!parts.length) parts.push(last);
    }
    if (trimLeftZero)
        parts[0] = parts[0].replace(/^0(?=\d[a-z]?)|\.000/, "");
    return parts.join(sep);
};

export const getAgo = (date, opts) => {
    if (!date) return;
    const ms = Date.now() - new Date(date);
    return `${ms < 0 ? "seconds" : get_dur(ms, {sep: " ", trimLeftZero: 1, addUnit: 1, showMs: 1, topOnly: 2, trimUnits: 1, ...opts})} ago`;
};

export const get_Hmm = (dt) => {
    if (typeof dt === "number") dt = new Date(dt);
    return dt.getHours() +":"+('0'+dt.getMinutes()).substr(-2);
};

export const get_ddMM = (dt) => {
    if (typeof dt === "number") dt = new Date(dt);
    return dt.getDate() +"/"+(dt.getMonth()+1);
};

export const get_ddMM_Hmm = (dt, noDate) => {
    if (typeof dt === "number") dt = new Date(dt);
    return (!noDate? get_ddMM(dt)+", " : "") + get_Hmm(dt);
};

export const getDateTech = () =>                // moment().format("YYYY-MM-DD");
    new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0];

export function convertToCSV(jsonData) {
    const headers = Object.keys(jsonData[0]);

    return headers +'\n' + jsonData.map(obj => Object.values(obj)).join('\n');
}

export const msTZ = new Date().getTimezoneOffset() *60* -1000;
export const isoToMs = iso => new Date(iso).getTime() + msTZ + MS_DAY;
export const msToInputDate = ms => ms*ms > 0? new Date(ms).toISOString().slice(0,10) : null;
export const msToDays = ms => {
    ms = new Date(ms) - Date.now();
    return ms*ms > 0? Math.ceil(ms / MS_DAY) : null;
};
export const utcMsToDate = ms => new Date(ms + msTZ).toISOString().slice(0,10);
export const dateToUtcMs = ds => new Date(ds).getTime() ;

// Returns name of caller function, or given idx, index of previous caller in the call stack.
export const funcName = (idx, opts) => getCallStack(idx ?? 2, opts);      // new Error().stack.match(/(?<=at )\w+/g)[idx ?? 1];

// Returns given idx, name of caller index in the call stack, otherwise returns an array of all function names in the call stack.
export const getCallStack = (idx, opts = {}) => {
    const orig = Error.prepareStackTrace;
    Error.prepareStackTrace = (error, stack) => stack;
    const {stack} = new Error();
    Error.prepareStackTrace = orig;
    return opts.nonNull?
        stack.slice(idx).findPred(v => v.getFunctionName()) :
        idx? stack[idx]?.getFunctionName() :
            stack.map(s => s.getFunctionName());
}

export async function timed(func) {
    let start = performance.now();
    await func();
    console.log(`Function ${func.name} took ${(performance.now() - start) | 0}ms`);
}

export const isInteger = num => /^-?[0-9]+$/.test(num+'');
export const getPct = (v, m, decimals = 1) => ((v / m * (10 ** (2+decimals)) |0) / (10 ** decimals)) + '%';

export const commafy = n => (n && !isNaN(n) || n === 0) && (n * 1).toLocaleString();
export const commafyPlural = (n, text) => n && !isNaN(n) || n === 0? `${(n*1).toLocaleString()} ${text}${(n*1).plural}` : undefined;


export const pickKeys = (obj, ...keys) => keys.flat().reduce((a, b) => ((obj[b] !== undefined || obj.hasOwnProperty(b)) && (a[b] = obj[b]), a), {});
export const sortKeys = obj => pickKeys(obj, Object.keys(obj).sort());

// Creates an object with keys from array or object, setting the values with the result of pred(key,value)
export function objMap(obj, pred) {
    if (Array.isArray(obj))
        return obj.reduce((a,k,i) => ((a[k] = pred(k,i)), a), {});
    else
        return Object.entries(obj).reduce((a,[k,v], i) => ((a[k] = pred(k,v,i)), a), {});
}

// Given array, creates an object with {key:vals} returned from pred(value, idx)
export const mapArrToObj = (objArr, pred) => objArr.reduce((a, k, i) => Object.assign(a, pred(k, i)), {});

// Remove all key/values from an object.
export const clearObj = o => Object.keys(o).forEach(k => delete o[k]);

/**
 * Given an Object and a list of sorter keys, returns a sorted array of [key, value]. Missing keys in either arrays will be dropped.
 *  @param obj object to sort.
 *  @param sorterArr array of keys corresponding to object keys, in arbitrary sort order.
 * */
export function sortObjToTupleByAnotherArr(obj, sorterArr) {
    return sorterArr.filter(k => obj[k]).map(k => obj[k] && ([k, obj[k]])).filter(v => v);
}

/**
 * Returns sorted array of objects according to another array. Missing keys in either arrays will be dropped.
 *  @param objArr array of objects to sort.
 *  @param key key within objArr objects that will be used to match vs sorterObj
 *  @param sorterArr array of keys corresponding to key keys, in arbitrary sort order.
 * */
export function sortObjArrByAnotherArr(objArr, key, sorterArr) {
    const toObj = mapArrToObj(objArr, o => ({[o[key]]: o}));
    return sorterArr.map(k => toObj[k]).filter(v => v);
}

// Create an object holding only keys where pred(key,value,i) is true
export const filterKeys = (obj, pred) => Object.entries(obj).reduce((a, [k, v], i) => ((pred(k, v, i) && (a[k] = v)), a), {});

// Convert object to array with the keys inserted into each item as k.
export const objToArrK = obj => Object.entries(obj).map(([k, v]) => ({k, ...(typeof v === "object" ? v : {[k]:v})}));

export const objToArrKH = obj => isObject(obj) && Object.entries(obj).map(([h, k]) => ({
        h: h.fromKebabCase().splitCamel().capitalizeFirst(),
        k: Array.isArray(k) ? k.map(v => isElement(v) ? v: isObject(v) ? objToArrKH(v) : v) : isElement(k) ? k: isObject(k) ? objToArrKH(k) : k
    }));

export const isObject = (v) => typeof v === "object" && v !== null && !Array.isArray(v);

export const objOmit = (obj, keys) => keys.reduce((o, k) => {
    const {[k]: _, ...p} = o;
    return p;
}, obj);

export const isStringRTL = s => /[\u0590-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(s)

export const makeArr = n => [...new Array(n).keys()];
export const isInRange = (v, min, max) => v >= min && v <= max;
export const minMax = (v, min, max) => Math.max(min, Math.min(max, v));
export const funcOrValOr = (obj, params, or) => typeof obj === "function" ? obj(params) : obj ?? or;

export function randomNot(limit, not) {                     // keep generating random until number is not not.
    let r;
    do r = Math.random() * limit | 0; while (limit > 1 && r === not);
    return r;
}

export const comparators = {
    number: (a,b) => a - b,                 // can be used for boolean, numerical strings and Date objects.
    numberRev: (a,b) => b - a,
    numberSig: (a,b) => a === b? 0 : a === undefined? 1 : b === undefined? -1 : a - b,   // Significant: undefineds go last
    numberSigRev: (a,b) => a === b? 0 : a === undefined? 1 : b === undefined? -1 : b - a,
    string: (a,b) => a.localeCompare(b),
    stringRev: (a,b) => b.localeCompare(a),
    stringSig: (a,b) => a === b? 0 : !a? 1 : !b? -1 : a.localeCompare(b),
    stringSigRev: (a,b) => a === b? 0 : !a? 1 : !b? -1 : b.localeCompare(a),
    dateSig: (a, b) => a === b ? 0 : !a ? 1 : !b ? -1 : new Date(a) - new Date(b),
    dateSigRev: (b, a) => a === b ? 0 : !a ? 1 : !b ? -1 : new Date(a) - new Date(b),
    numberArrFirst: (a,b) => a === b? 0 : a === undefined? 1 : b === undefined? -1 : a[0] - b[0],
    numberArrFirstRev: (a,b) => a === b? 0 : a === undefined? 1 : b === undefined? -1 : b[0] - a[0],
    stringArrFirst: (a,b) => a === b? 0 : !a? 1 : !b? -1 : a[0].localeCompare(b[0]),
    stringArrFirstRev: (a,b) => a === b? 0 : !a? 1 : !b? -1 : b[0].localeCompare(a[0]),
};

export const comparatorRev = comp => (a,b) => comp(b,a);

export const comparatorsField = (comp, field, isRev) => !isRev?
    ((a,b) => comp(a?.[field], b?.[field])) :
    ((b,a) => comp(a?.[field], b?.[field]));

export const comparatorsPred = (comp, pred, isRev) => !isRev?
    ((a,b) => comp(pred(a), pred(b))) :
    ((b,a) => comp(pred(a), pred(b)));

if (!Array.prototype.removeFirst) {
    Object.defineProperties(Number.prototype, {
        plural: {get() { return this === 1 ? "" : "s"}},                            // returns plural 's' if number is not 1
        between: {value(r1, r2) { return this >= r1 && this < r2}},
    });

    Object.defineProperties(Array.prototype, {
        last: {get() { return this[this.length - 1]}},                              // returns last item in array
        removeFirst: {                                                              // remove first val item. replace with toVals if given. returns removed item.
            value(val, ...toVals) {
                const idx = this.indexOf(val);
                if (idx !== -1)
                    return this.splice(idx, 1, ...toVals)[0];
            }
        },
        removeFirstPred: {                                                          // remove first item answering predicate. replace with toVals if given. returns removed item.
            value(pred, ...toVals) {
                const idx = this.findIndex(pred);
                if (idx !== -1)
                    return this.splice(idx, 1, ...toVals)[0];
            }
        },
        removeAny: {                                                                // remove all val items from array.
            value(val) {
                for (let i = 0; (i = this.indexOf(val, i)) >= 0; this.splice(i, 1));
                return this;
            }
        },
        removeIndexes: {                                                            // removes idxArr indexes from array. use slice() if you want a copy.
            value(idxArr) {
                idxArr.slice().sort().reverse().forEach(i => this.splice(i, 1));
                return this;
            }
        },
        orderBy: {                                                                  // sort with a sortSpec as: [{f: string, comparator(a,b)}, ...]
            value(sortSpec) {
                return this.sort((oa,ob) => {
                    for (let {tmp, f, comparator} of sortSpec)
                        if ((tmp = comparator(oa, ob, f))) return tmp;
                    return 0;
                });
            }
        },
        findPred: {                                                                 // return the first non-falsy result of pred()
            value(pred) {
                let val;
                this.some((v,i,a) => val = pred(v,i,a));
                return val;
            }
        },
        toggleItem: {                                                               // add / remove item from array
            value(item) {
                const rmv = this.filter(itm => itm !== item);
                return rmv.length !== this.length? rmv : rmv.concat(item);
            }
        },
        interleave: {                                                               // interleave a new item between each of the existing items in array. like join(item) for arrays returns a new copy.
            value(item) {
                if (this.length < 2) return this.slice();
                const laced = this.slice(0, this.length-1).map(e => [e, item]);
                return [].concat(...laced, this[this.length-1]);
            }
        },
        groupBy: {
            value(getGroup) {                                                     // goes over an array and groups by the key returned from getGroup(ent).
                return this.reduce((acc, ent) => {                                // @returns a dictionary of: {[groupBy]: [values...]}
                    const group = getGroup(ent);
                    (acc[group] ?? (acc[group] = [])).push(ent);
                    return acc;
                }, {});
            }
        },
        undup: {
            value() {
                return Array.from(new Set(this));
            }
        },
        equals: {
            value(arr2) {
                return this === arr2 ||
                    (this.length === arr2?.length && this.every((v,i) => v === arr2[i]));
            }
        },
        threadAt: {
            value(value, idx) {
                return [...this.slice(0, idx), value, ...this.slice(idx, this.length)];
            }
        },
        spliceArr: {
            value(start, deleteCount, ...newItems) {
                this.splice(start, deleteCount, ...newItems);
                return this;
            }
        },
        move: {
            value(from, to) {
                return this.spliceArr(to, 0, this.splice(from, 1)[0]);
            }
        },
    });


    Object.defineProperties(String.prototype, {
        capitalize: {value() { return this.replace(/(^\w|\s\w)(\S*)/g, (_,m1,m2) => m1.toUpperCase()+m2.toLowerCase())}},   // capitalize all words
        capitalizeFirst: {value() { return this[0].toUpperCase()+this.slice(1);}},                                          // capitalize first word only
        toKebabCase: {value () {return this.split(" ").join("_")}},
        fromKebabCase: {value () {return this.split("_").join(" ")}},
        splitCamel: {value () {return this.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}},
        uncamel: {value() { return this.replace(/[A-Z]/g, m => ' '+m.toLowerCase()).trim()}},                               // convert camelCase string into "camel case"
        format: {                                                                   // "My name is $2. I live in $1".format("MZ", "Blah")
            value: function (...args) {
                return this.replace(/\$(\d+)/g, (all, match) => args[match-1]);
            }
        },
        formatRegex: {                                                             // match = string.match(/regex/); "$1 or $<namedGroup>".format(match.slice(1), match.groups)
            value: function (groups, named) {
                return this.replace(/\$(\d+|<\w+>)/g, (all, grp) => groups[grp] ?? named?.[grp.slice(1, grp.length-1)] ?? "");
            }
        },
        before: {                                                                   // Return the string before first occurrence of given string
            value: function (sep) {                                                 // If not found, returns all string
                const p = this.indexOf(sep);
                return p < 0? this.toString() : this.substring(0, p);
            }
        },
        beforeLast: {                                                               // Return the string before last occurrence of given string
            value: function (sep) {                                                 // If not found, returns all string
                const p = this.lastIndexOf(sep);
                return p < 0? this.toString() : this.substring(0, p);
            }
        },
        after: {                                                                    // Return string after first occurrence of given string
            value: function (sep) {                                                 // If not found, returns ""
                const p = this.indexOf(sep);
                return p < 0 ? "" : this.substring(p + sep.length);
            }
        },
        afterLast: {                                                                // Return string after last occurrence of given string
            value: function (sep) {                                                 // If not found, returns ""
                const p = this.lastIndexOf(sep);
                return p < 0 ? "" : this.substring(p + sep.length);
            }
        },
        hash: {                                                                // Return string after last occurrence of given string
            value: function () {                                                 // If not found, returns ""
                let hash = 9;
                for (let i = 0; i < this.length; i++)
                    hash = Math.imul(hash ^ this.charCodeAt(i), 9 ** 9);
                return hash ^ hash >>> 9;
            }
        },
    });

    Object.defineProperties(Set.prototype, {
        toggle: {value(val) { return this.delete(val) || this.add(val) }},
    });
}


export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export function unCatch(func, ...params) {
    try {
        return func(...params);
    } catch (e) {}
}

// check return instanceof Error
export function catchErr(func, ...params) {
    try {
        return func(...params);
    } catch (e) {
        return e;
    }
}


export class CallbackRegistry {
    curVal = undefined;
    fetcher;
    inFetch = false;
    subs = [];

    constructor(fetcher) {
        this.setFetcher(fetcher);
    }

    setFetcher = fetcher => {
        this.fetcher = fetcher;
        fetcher && this.refetch();
    }

    subscribe = cb => {
        this.subs.push(cb);
        if (this.curVal)
            cb(this.curVal);
        return () => this.unsubscribe(cb);
    };

    setVal = val => {
        this.curVal = val;
        this.subs.forEach(sub => sub(val));
        return val;
    };

    refetch = () => {
        if (this.inFetch) return;       // prevent parallel fetching.
        this.inFetch = true;
        this.fetcher(val => {
            this.inFetch = false;
            this.setVal(val);
        });
    };
    unsubscribe = cb => this.subs.removeFirst(cb);
    touch = () => this.setVal(this.curVal);
    getCur = () => this.curVal;
}

const SI_SYMBOL = "kMGTPE";                                     // International System of Units

/**
 * Abbreviates number to up to 3 digits with size symbol.
 *  @param num number to abbreviate.
 * */
export function abvNum(num) {                                      // Abbreviate Number
    const digits = Math.log10(Math.abs(num)) |0;            // what tier? (determines SI symbol)
    const sig = digits % 3;                                 // how many significant digits to show, after the first
    return (Math.round(num / Math.pow(10, digits - sig - !sig)) / (sig? 1 : 10)) +    // if only first, show 1 decimal
        (SI_SYMBOL[Math.floor(digits / 3 - 1)] ?? "");      // format number and add suffix
}

/**
 * Abbreviates number to up to 3 digits with size symbol.
 *  @param num number to abbreviate.
 *  @param all (boolean)?: return number relative to all smaller abbreviation symbols.
 *  @param minAbv (number)?: if num below minAbv, returns num just commafied.
 *  @param div (number)?: divisor. default: 1000.
 * */
export function abvNumEx(num, {all, minAbv, div} = {}) {
    div = div ?? 1000;
    if (Math.abs(num) < (minAbv ?? div)) return num.toLocaleString();
    let abv = "";
    for (let tier = Math.log(num) / Math.log(div) |0, i = 0; tier && (!i || all); tier--, i++) {  // what tier? (determines SI symbol)
        let an = num / Math.pow(div, tier);
        an = an < 10 ? (an * 10 +0.5 | 0) / 10 : an +0.5 | 0;                                     // if single digit (no exponents), show fraction
        abv+= (!abv? "" : "  ")+ (!i? an : an.toLocaleString()) + SI_SYMBOL[tier - 1];   // format number and add suffix
    }
    return !abv? num.toString() : !all? abv : abv +"  "+ num.toLocaleString();           // if zero, we don't need a suffix
}


// A simple but high quality 53-bit hash. It's quite fast, provides very good* hash distribution, and because it outputs 53 bits,
// has significantly lower collision rates compared to any 32-bit hash
export function cyrb53(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = str.length - 1, ch; i >= 0; i--) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}


// Returns a "debounced" function version of a callback.
// delay can be number of milliseconds to debounce or a function that returns that number on every cb.
// opts can have: leading: if positive cb called immediately if not called recently within delay.
// debounced.cancel() can be called to cancel any currently pending trigger.
// Warning: not React aware - care should be taken to cancel if component removed.
//
export function debounce(cb, delay = 0, opts = {}) {
    let prevAt, timer;

    const debounced = (...args) => {
        const msDelay = funcOrValOr(delay);             // allow delay to be a function called when actually issuing the func.
        const now = Date.now();
        const isRecent = now - prevAt < msDelay;
        prevAt = now;

        clearTimeout(timer);
        if (!msDelay || (!isRecent && opts.leading))
            cb(...args);
        else
            timer = setTimeout(() => cb(...args), msDelay);
    };
    debounced.cancel = () => clearTimeout(timer);

    return debounced;
}

// Returns a debounced version of func that delays invoking by milliseconds. (based on
// delay can be a dynamic callback function issued when actually calling the func.
//
// options:
//   if leading: call func immediately if not called recently within delay.
//   if accumulate: debounced func will be called with an array of all the arguments received while waiting.
//
export function debounceEx(cb, delay = 0, opts = {}) {
    let lastCallAt, deferred = {}, timer, pendingArgs = [];

    return function debounced() {
        const msDelay = funcOrValOr(delay);             // allow delay to be a function called when actually issuing the func.
        const now = Date.now();
        const isRecent = now - lastCallAt < msDelay;
        lastCallAt = now;

        pendingArgs.push([...arguments]);

        // if (!isRecent && opts.leading)
        //     return !opts.accumulate?
        //         Promise.resolve(cb.call.apply(cb, [this].concat(args))) :
        //         Promise.resolve(cb.call(this, [args])).then(result => result[0]);

        if (!timer)
            deferred.promise = new Promise(
                (resolve, reject) => Object.assign(deferred, {resolve, reject}));
        else
            clearTimeout(timer);

        if (!isRecent && opts.leading)
            return flush();

        timer = setTimeout(flush, msDelay);

        if (opts.accumulate) {
            const argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(results => results[argsIndex]);
        }

        return deferred.promise;
    }

    function flush() {
        const curDeferred = {...deferred};
        const curArgs = pendingArgs;
        timer = undefined;
        pendingArgs = [];

        return Promise.resolve(opts.accumulate ?
            cb.call(this, curArgs) :
            cb.apply(this, curArgs.last))
            .then(curDeferred.resolve, curDeferred.reject);
    }
}



let curCacheSize = 0;
const dataCache = {};

/**
 * Stores objects in memory cache. If exceeds maxCacheSize, purges least accessed objects. Objects are stored as json strings.
 * @param key - identifies the data object. Can be a string or an object (which will be stringified).
 * @param data - actual data object to store
 * @param maxCacheSize - (default 16Mb)
 * @param curObjectAlwaysKept - allow current object to exceed cache size (default true)
 */
export function cacheData({key, data, maxCacheSize = 1024 ** 3 * 16, curObjectAlwaysKept = true, created}) {
    const jKey = typeof key === "string"? key : JSON.stringify(key);    // stringify key if needed
    //console.log("cacheData jKey", jKey)
    if (dataCache[jKey]) {
        curCacheSize -= dataCache[jKey].json.length;                    // remove previous object size
        delete dataCache[jKey];
    }
    const json = JSON.stringify(data);
    const size = json.length;
    if (!curObjectAlwaysKept && size > maxCacheSize) return;

    curCacheSize += size;
    if (curCacheSize > maxCacheSize) {
        Object.values(dataCache)
            .sort((a,b) => a.accessed - b.accessed)
            .find(obj => {
                curCacheSize -= obj.json.length;
                delete dataCache[obj.jKey];
                return curCacheSize <= maxCacheSize;
            });
    }
    dataCache[jKey] = {jKey, json, created: created ?? new Date(), accessed: new Date()};
}

/**
 * Fetch object from memory cache, based on key.
 * @param key
 * @return {{data: any, created: date}|null}
 * data - cached object.
 * age - in milliseconds since created.
 */
export function cacheFetch(key) {
    const jKey = typeof key === "string"? key : JSON.stringify(key);    // stringify key if needed
    const obj = dataCache[jKey];
    if (!obj) return null;
    obj.accessed = new Date();
    return {data: JSON.parse(obj.json), created: obj.created};
}

export function cacheDirty({key}) {
    const jKey = typeof key === "string"? key : JSON.stringify(key);    // stringify key if needed
    delete dataCache[jKey];
}
